// extracted by mini-css-extract-plugin
module.exports = {"mkPlaceBreadcrum":"MarketplaceBreadcumb_mkPlaceBreadcrum__PWCMy","topSectionBox":"MarketplaceBreadcumb_topSectionBox__aKD1G","breadcrum":"MarketplaceBreadcumb_breadcrum__evHKv"};